import type { EarlyLoanRepaymentFeatureConfig } from '../../../types/features/EarlyLoanRepaymentFeatureConfig';

export const earlyLoanRepayment: EarlyLoanRepaymentFeatureConfig = {
    preloadRepaymentOptions: false,
    isFullRepaymentPossible: false,
    summary: {
        showSubtitle: false,
        showSubtitleWhatPointsToElectronicStorage: false,
        showExtraordinaryRepaymentMessage: false,
        showLoanNumber: false,
        showPaidFromAccount: false,
        showCurrentInstalment: false,
        showFaqSection: false,
        showDocumentDownload: false,
        showFees: false,
        showSimplifiedFees: false,
        showCurrentMaturityDate: false,
        showNextMaturityDate: false,
        showNextInstallmentDateFromAccountResponse: false,
        showNextInstallmentDateFromRepaymentInfoResponse: false,
        showNextInstallmentAmount: false,
        showNewInstallmentAmount: false,
        showRemainingInstallmentsBeforeReimbursement: false,
        showRemainingInstallmentsAfterReimbursement: false,
        showShortenedInstallments: false,
        showInstallmentFrequency: false,
        showRemainingInstallments: false,
        showCurrentDueDate: false,
        showNewDueDate: false,
        showCurrentLoanBalance: false,
        showNewLoanBalance: false,
        showPaidInterest: false,
    },
    amountInput: {
        showFeesMessage: false,
        showPossibleAmountRangeInfo: false,
    },
    inputValidation: {
        overTheMaximumKey: '',
    },
    errorScreen: {
        showPhoneSupportError: false,
        showAMLSuspectError: false,
        conditionNotMetKey: '',
        amlSuspectKey: '',
    },
    adjustLoan: {
        showTooShortPeriodMessage: false,
        showInfoMessageAboutSpecificLoanRepayment: false,
        showInfoMessageAboutHigherPayment: false,
    },
};
